import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'underscore'

class ModalView extends Backbone.View {
    events () {
        return {
            'click  .closeModal': 'closeModal',
            'click  .btn-agree': 'closeModal',
            'click  .modal': 'openModal'
        }
    }

    /**
     * A classe pai Backbone.View já se ocupa de tratar os options e atribuir os valores
     * o backbone trata magicamente os atributos enviados pelo options se esses corresponderem a um atributo nativo do backbone
     * ex.: el, className, tagName, model
     *
     * Os atributos são enviados no arquivo modal-list-view.js
     */
    initialize (options) {
        try {
            this.id = this.$el.attr('id')
            // this.id = this.$el.id - acho que isso também funciona

            // Dessa forma essa view vai escutar os buttons dinamicamente
            // pelo data-target
            $('body').on('click', `.modal[data-target='${this.id}']`, _.bind(this.openModal, this))
        } catch (ex) {
            console.error(ex)
        }
    }

    openModal (ev) {
        ev.preventDefault()
        this.$el.toggleClass('active')
    }

    closeModal (ev) {
        ev.preventDefault()
        this.$el.removeClass('active')
    }
}

export default ModalView
